import { FC } from 'react';
import { Button, Typography } from '@mui/material';

import { ActionCallout } from '../../../../../components/Callout/ActionCallout';
import { CardContent, CardHeader } from './Card';
import CollapsibleCard, { CollapsibleCardProps } from '../../../../../components/Card/CollapsibleCard/CollapsibleCard';
import CollapsibleCardExpandArea from '../../../../../components/Card/CollapsibleCard/CollapsibleCardExpandArea';
import CollapsibleCardExpandButton from '../../../../../components/Card/CollapsibleCard/CollapsibleCardExpandButton';
import Column from '../../../../../components/Column';
import EmptyCardContent from '../../../../../components/Card/EmptyCardContent';
import Row from '../../../../../components/Row';

import { PAGE_TABS } from '../Tabs/CampaignPageTabs';
import { Campaign } from '../../../../../types/Campaign';
import { useCampaignPageContext } from '../../../../../hooks/Contexts/Pages/CampaignPageContext';

interface CampaignActionCardProps {
    campaign: Campaign;
    slotProps?: {
        collapsibleCard?: Partial<CollapsibleCardProps>;
    };
}

const CampaignActionCard: FC<CampaignActionCardProps> = ({ campaign, slotProps = {} }) => {
    const { selectTab } = useCampaignPageContext();

    const hasUpdates: boolean = campaign?.hasUpdates;

    const handleOnCampaignChangeRequestReview = (): void => {
        selectTab(null, PAGE_TABS['change-history'].slug);
    };

    const handleOnCampaignCreativeReview = (): void => {
        selectTab(null, PAGE_TABS['creatives'].slug);
    };

    return (
        <CollapsibleCard
            defaultExpanded
            {...slotProps?.collapsibleCard}
            sx={{
                '& .MuiCardContent-root:last-child': {
                    pb: (theme) => theme.spacing(2),
                },
            }}
        >
            <CardHeader
                title={
                    <Row alignItems="center" gap={1}>
                        <Typography variant="body1">Action Required</Typography>
                    </Row>
                }
                action={<CollapsibleCardExpandButton />}
            />
            <CollapsibleCardExpandArea>
                <CardContent>
                    {hasUpdates ? (
                        <Column gap={2}>
                            {campaign?.hasUpdates && (
                                <ActionCallout>
                                    <Row alignItems="center" justifyContent="space-between">
                                        <Typography variant="subtitle2" color="text.primary">
                                            1 Pending change request approval
                                        </Typography>

                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={handleOnCampaignChangeRequestReview}
                                        >
                                            Review
                                        </Button>
                                    </Row>
                                </ActionCallout>
                            )}

                            <ActionCallout>
                                <Row alignItems="center" justifyContent="space-between">
                                    <Typography variant="subtitle2" color="text.primary">
                                        1 Pending Creative Approval
                                    </Typography>

                                    <Button variant="outlined" color="primary" onClick={handleOnCampaignCreativeReview}>
                                        Review
                                    </Button>
                                </Row>
                            </ActionCallout>
                        </Column>
                    ) : (
                        <EmptyCardContent
                            height={125}
                            message={
                                campaign.deliveryStatusId === 'DRAFT'
                                    ? 'No action available'
                                    : "You're all caught up! No actions needed at the moment."
                            }
                        />
                    )}
                </CardContent>
            </CollapsibleCardExpandArea>
        </CollapsibleCard>
    );
};

export default CampaignActionCard;
